module.exports = __webpack_public_path__ + "static/media/logo_dev.ec2f7b2a.png";